module.exports = __webpack_public_path__ + "assets/img/20-l.1311fc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/20-l.jpg
// module id = aZbR
// module chunks = 0